
import { isPlatformBrowser } from '@angular/common';
import { Router } from "@angular/router";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import {
  HttpErrorResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { ApiService } from "../services/api.service";
import { UtilService } from "../services/util.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private _authService: AuthService,
    private _api: ApiService,
    private util: UtilService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (!(err instanceof HttpErrorResponse)) {
          return throwError(() => err);
        }

        const isGetDomainRequest = request.url.includes('get-domain');
        const isKbContentRequest =
          request.url.includes('cat-article') ||
          request.url.includes('get-single-article') ||
          request.url.includes('single-cat') ||
          request.url.includes('search-article');

        if (err.status === 0) {
          return throwError(() => err);
        }

        if (err.status === 401) {
          if (isPlatformBrowser(this.platformId)) {
            this.router.navigateByUrl("/auth/signin");
            this._authService.signOut();
          }
        }
        if (err.status === 500) {
          if (
            err.error.exception ==
            "Stancl\\Tenancy\\Exceptions\\TenantCouldNotBeIdentifiedOnDomainException" ||
            err.error.exception ==
            "Stancl\\Tenancy\\Exceptions\\NotASubdomainException"
          ) {
            if (isPlatformBrowser(this.platformId)) {
              window.location.href = "https://desku.io/";
            }
            return throwError(() => err);
          } else if (isPlatformBrowser(this.platformId)) {
            this.router.navigateByUrl("/500");
            this.util.showToast("Internal server error.");
          }
        }
        if (err.status === 422) {
          const errors = err.error?.errors;
          const isKbLangError = !!errors?.kb_lang;

          if (isKbLangError && isKbContentRequest && !this._api.isDomainBlocked()) {
            this._api.navigateToKnowledgebaseError(404);
          }

          return throwError(errors ?? err.error);
        }

        if (err.status === 400) {
          this._api.checkSubscriotion.next(false);
          this._api.isSubscriptionOver.next(true);
          if (isPlatformBrowser(this.platformId)) {
            this.router.navigateByUrl("/manage/subscription");
          }
        }
        if (err.status === 410 && isGetDomainRequest) {
          this._api.handleDomainUnavailable(410);
          return throwError(() => err);
        }
        if (err.status === 404) {
          if (isGetDomainRequest) {
            this._api.handleDomainUnavailable(404);
            return throwError(() => err);
          }
          if (request.url.includes('kb-page-builder') || isKbContentRequest) {
            return throwError(() => err);
          }
          if (!this._api.isDomainBlocked()) {
            this._api.navigateToKnowledgebaseError(404);
          }
          return throwError(() => err);
        }
        const error = err.error?.error || err.error?.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
